import React ,{useEffect,useState,useContext } from 'react'
 
import axios from 'axios';
import {  useForm } from "react-hook-form";
import { Col, Row, Form, Button, Toast  } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from '../../component/Loader/Loader';
import Variables from "../../constants/Variables";
import {TechStacks} from "../../constants/TechStacks";
import { AuthContext } from "../../contexts/AuthProvider";
import { toast, Toaster } from 'react-hot-toast';
import { axiosOpen } from "../../api/axios";
import AddPortfolioForm from './AddPortfolioForm';

const Addportfolio = ( ) => {
    const [loader, setLoader] = useState(true);
    const [data, setData] = useState('');
    const [portfolios, setPortfolios] = useState('');
    const [project, setProject] = useState('');
    const [techstacks, setTechstacks] = useState('');
    const [newtechstacks, setNewTechstacks] = useState(''); 
    const [list, setList] = useState(''); 
    const techStacks = Variables.techStacks;
    // const stacks = TechStacks.techStacks;

    // const { user } = useContext(AuthContext);
    const { register } = useForm();
    useEffect(() => {
     
      async function fetchTechStacks() {
      await axiosOpen.get("api/techstack/getAllTechstacks/"+localStorage.getItem('userID'))
    .then(response => {
      let result = response;
      var stacks = [];
      var index
      // result.data.map((portfolio)=>{
      //     index = TechStacks.indexOf(portfolio.tech_stack);
      //     console.log('index',index)
      //       if (index == -1) { // only splice array when item is found
      //         TechStacks.splice(index, 1); // 2nd parameter means remove one item only
      //       }
      //   })

      
        result.data.map((portfolio)=>{
          stacks.push(portfolio.tech_stack)
        })
      
      const difference = TechStacks.filter(x => !stacks.includes(x));
      
        setData(difference.sort());
        setLoader(false);
      })
    .catch(error => {
      
      console.log(error);
    });
  }fetchTechStacks();
    
    }, [loader]);
 

   
 
  return (
    <>
    { data == '' ? (
        <Loader/>
    ) : (
      <>
      <AddPortfolioForm 
      stacks={data} loader={loader}/>
      </>
    )}

 </>
  )
}

export default Addportfolio;